// extracted by mini-css-extract-plugin
module.exports = {"hidden_input":"style_hidden_input__1pFjK","toggle_container":"style_toggle_container__19uCY","checked":"style_checked__3rLo2","ball":"style_ball___miiG"};